import React from "react";
import PatientTotalSummary from "./PatientTotalSummary";
import PatientPeriodInsights from "./PatientPeriodInsights";
import { canViewPatientStatistics } from "../../utils/moduleAccess";
import useCurrentUser from "../../hooks/useCurrentUser";

/**
 * Patient Statistics tab layout:
 * 1) Total patient summary (no date filter)
 * 2) Period insights — date filter + census + distribution
 * Admin + OA — backend enforces adminOrOa on /dashboard/patients/*.
 */
const PatientStatistics = () => {
  const { role, user } = useCurrentUser();

  if (!canViewPatientStatistics(role || user)) {
    return (
      <p className="text-sm text-slate-500 py-6 text-center">
        You do not have permission to view patient statistics.
      </p>
    );
  }

  return (
    <div className="space-y-4 animate-fade-in">
      <PatientTotalSummary />
      <PatientPeriodInsights />
    </div>
  );
};

export default PatientStatistics;
